import { RightOutlined } from '@ant-design/icons';
import React, { useState } from 'react';
import styled from 'styled-components';

const Style = styled.div`
  margin-bottom: 34px;

  .comp-header { 
    display: flex;
    gap: 14px;

    h1 {
      font-size: 20px;
      font-weight: 600;
      cursor: pointer;
    }

    svg {
      cursor: pointer;
    }
  }

  &.toggled {
    .comp-header {
      margin-bottom: var(--size-lg);
      
      svg {
        transform: rotate(90deg);
      }
    }
  }
`;

const headers = {
  stateOfMeasures: 'State of Measures',
  associatedEvents: 'Associated Events',
};

export default function ToggleableComponent({
  type = '',
  children = null,
}) {
  const [toggled, setToggled] = useState(true);
  return (
    <Style className={toggled ? 'toggled' : 'default'}>
      <div className="comp-header">
        <div className="cont">
          <h1
            onClick={() => setToggled((prev) => !prev)}
          >
            {headers[type] || 'No Type'}
          </h1>
        </div>
        <div className="cont">
          <RightOutlined
            onClick={() => setToggled((prev) => !prev)}
          />
        </div>
      </div>
      {toggled && children}
    </Style>
  );
}
